import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined,
})

// getters
const getters = {}

// actions
const actions = {
    // kayıtları getir (server-side pagination)
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)

        state.filterData = filterData

        let params = {
            page: page?.current,
            page_limit: page?.pageSize,
        }

        if (state.filterData) {
            params = {...params, ...state.filterData}
        }

        const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_gift_card'), {params})

        const {data, meta} = res.data

        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // yenile
    refresh({state, dispatch}) {
        dispatch('get', {
            page: state.table.pagination,
            filterData: state.filterData,
        })
    },

    // tekil getir (işlem geçmişiyle)
    async show({commit}, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_gift_card') + '/' + id)
        return response.data.data
    },

    // benzersiz kod üret
    async generateCode() {
        const response = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_gift_card_generate_code'))
        return response.data
    },

    // yeni hediye kartı
    async create({commit}, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_gift_card'), data)
        return response.data
    },

    // hediye kartı güncelle (kod / para birimi / açılış tutarı değişmez)
    async update({commit}, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('ecommerce_gift_card') + '/' + id, data)
        return response.data
    },

    // bakiye ayarla (± tutar, işaretli)
    async adjust({commit}, {id, amount, note}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_gift_card') + '/' + id + '/adjust', {amount, note})
        return response.data
    },

    // hediye kartı(ları) sil
    async delete({dispatch}, {id}) {
        let successDeleted = []
        if (!id || id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('ecommerce_gift_card') + '/' + id[i])
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                    successDeleted.push(id[i])
                } else {
                    this._vm.$message.error(data.message)
                }
            }
            dispatch('refresh')
            return successDeleted
        }
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
